/* ar-brown App (C) 2021 arbrown.co.jp All rights reserved.
 *******************************************************************************
 * Program ID:  OrderRecipientItemSegGdcList.js
 * $Revision:   Ver1.0
 * $Modtime:    $
 *******************************************************************************
 * Author      (作成／更新年月日、担当者)
 *  2024/11/27 Rayoo)niu : 新規作成
 *
 * Summary OrderRecipientItemSegGdcList画面
 *
 * Instructions / Preconditions
 *  なし
 *
 *******************************************************************************
 */
// pages
import React, { useEffect, useState } from "react";
/*  GraphQL API Acess */
import API, { graphqlOperation } from "@aws-amplify/api";
import { listALLOrderRecipientItemSegGdc } from "../graphql/queries";
/*  AWS標準設定 with Login Auth. */
import Amplify,{Auth} from "aws-amplify";
import awsconfig from "../aws-exports";
Amplify.configure(awsconfig);
import { Container,Row,Col,InputGroup } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  fixedTop: {
    position: "sticky",
    top: 0,
    boxShadow: "0 -1px 0 0 white,0 3px 0 0 #804F29,0 3px 0 0 transparent",
    backgroundColor: "white",
    zIndex: 9,
  },
  textFieldSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "transparent",
    border: "1px solid #707070",
    borderRadius: "6px",
    color: "black",
    width:"80%"
  },
  textlabelSearch:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    background: "rgb(91,56,9)",
    border: "1px solid #707070",
    color: "white",
    fontWeight: "bold",
    fontSize: '14px',
    alignItems: 'center',
    justifyContent: 'center',
    width:"20%"
  }
}));
const customTotal = (from, to, size) => (
  <span
    style={{ marginLeft: "1em" }}
    className="react-bootstrap-table-pagination-total"
  >
    {size} の結果の {from} から {to} を表示しています
  </span>
);
const pageButtonRenderer = ({ page, onPageChange }) => {
  const handleClick = (e) => {
    e.preventDefault();
    onPageChange(page);
  };
  return (
    <button className="btn-secondary btn" type="button" key={page}>
      <li className="page-item">
        <a style={{ color: "white" }} href="#" onClick={handleClick}>
          {page}
        </a>
      </li>
    </button>
  );
};

const sizePerPageRenderer = ({
  options,
  currSizePerPage,
  onSizePerPageChange,
}) => (
  <div className="btn-group" role="group">
    {options.map((option) => (
      <button
        key={option.text}
        type="button"
        onClick={() => onSizePerPageChange(option.page)}
        className={`btn ${
          currSizePerPage === `${option.page}` ? "btn-warning" : "btn-light"
        }`}
      >
        {option.text}
      </button>
    ))}
  </div>
);
const options = {
  paginationSize: 10,
  pageStartIndex: 1,
  showTotal: true,
  withFirstAndLast: true,
  firstPageText: "最初",
  prePageText: "戻る",
  nextPageText: "次へ",
  lastPageText: "最後",
  nextPageTitle: "最初のページ",
  prePageTitle: "プレページ",
  firstPageTitle: "次のページ",
  lastPageTitle: "最後のページ",
  paginationTotalRenderer: customTotal,
  sizePerPageRenderer: sizePerPageRenderer,
  pageButtonRenderer: pageButtonRenderer,
  disablePageTitle: true,
  sizePerPageList: [
    {
      text: "10",
      value: 10,
    },
    {
      text: "20",
      value: 20,
    },
    {
      text: "30",
      value: 30,
    },
  ],
};

export const OrderRecipientItemSegGdcList = () => {
  const [OrderRecipientItemSegGdcList, setOrderRecipientItemSegGdcList] =
    useState([]);
  const classes = useStyles();
  const [OrderRecipientCodeList, setOrderRecipientCodeList] = useState([]);
  const [ItemCodeList, setItemCodeList] = useState([]);
  const [ProductGroupsList, setProductGroupsList] = useState([]);
  const [SalesGroupList, setSalesGroupList] = useState([]);
  const [MarketList, setMarketList] = useState([]);
  const [SegmentList, setSegmentList] = useState([]);
  const [CommodityGrpText2List, setCommodityGrpText2List] = useState([]);
  const [ItemGroupList, setItemGroupList] = useState([]);
  const [progress, setProgress] = useState(false);
  const [searchValue, setSearchValue] = useState({
        OrderRecipientCode: "",
        ItemCode:"",
        SalesGroup:"",
        Market:"",
        Segment:"",
        CommodityGrpText2:"",
        ItemGroup:"",
        ProductGroups:""
        })
  const searchValueChange = (e, value,name) => {
    if(name === "ItemCode" || name === "CommodityGrpText2" || name === "ItemGroup" || name === "ProductGroups"){
      setSearchValue({ ...searchValue, [name]: value ? value : "" })
    }else{
      setSearchValue({ ...searchValue, [name]: value ? value.split(":")[0] : "" })
    }
  }
 async function searchData() {
  let dataAll = [];
  try {
    const listInfo = await API.graphql(
      graphqlOperation(listALLOrderRecipientItemSegGdc)
    );
    console.log(listInfo);
    dataAll = listInfo.data.listALLOrderRecipientItemSegGdc["items"];
    let nextToken = listInfo.data.listALLOrderRecipientItemSegGdc.nextToken;
    while (nextToken !== null) {
      let InvDataSec = await API.graphql(
        graphqlOperation(listALLOrderRecipientItemSegGdc, {
          nextToken: nextToken,
        })
      );
      nextToken = InvDataSec.data.listALLOrderRecipientItemSegGdc.nextToken;
      for (
        let i = 0;
        i < InvDataSec.data.listALLOrderRecipientItemSegGdc.items.length;
        i++
      ) {
        dataAll.push(InvDataSec.data.listALLOrderRecipientItemSegGdc.items[i]);
      }
    }
} catch (err) {
  console.log(err);
}
  return dataAll
  }
  const searchBtn = async () => {
    setProgress(true)
    let arr = [];
    let dataAll = [];
    let obj = {};
    try {
      dataAll = await searchData()
      } catch (error) {
      console.log(error);
      }
      obj = searchValue;
      dataAll.forEach(item => {
        let flag = true
        if (Object.keys(obj).length !== 0) {
          for (let name in obj) {
            if (obj[name] !== "") {
              if (item[name]) {
                if (!(item[name]).includes(obj[name])) {
                  flag = false;
                  break;
                }
              } else {
                flag = false
                break;
              }
            }
          }
        }
        if (flag === true) {
          arr.push(item)
        }
      })
      arr = multiSort(arr,sortByOrderRecipientName)
      setOrderRecipientItemSegGdcList(arr);
      setProgress(false)
  }
  const searchClear = async()=>{
    setProgress(true)
    let arr = [];
    try {
      arr = await searchData()
      } catch (error) {
        if (error.message === 'No current user') {
            //ユーザープールに障害が発生した場合
            console.log('User pool is invalid.Please reauthenticate.');
            //ログイン画面に戻る
            signOut();
        } else {
            //他のエラーを処理する
            console.log('An error occurred:', error);
        }
      }
      setSearchValue({ OrderRecipientCode: "",ItemCode:"",
        SalesGroup:"",
        Market:"",
        Segment:"",
        CommodityGrpText2:"",
        ItemGroup:"",
        ProductGroups:""})
      arr = multiSort(arr,sortByOrderRecipientName)
      setOrderRecipientItemSegGdcList(arr);
      setProgress(false)
  }
  const signOut = async () => {
    await Auth.signOut();
    try {
        await Auth.signOut();
    } catch (error) {
        console.log("error signing out: ", error);
    }
    document.location.reload();
  };
  const getTypePriority = (str) => {
    if (!str || str.trim() === "") return 99;
    const firstChar = str[0];
    if (/^[0-9]/.test(firstChar)) return 1;
    if (/^[a-zA-Z]/.test(firstChar)) return 2;
    if (/^[\u30A0-\u30FF]/.test(firstChar)) return 3;
    if (/^[\u3040-\u309F\u4E00-\u9FFF]/.test(firstChar)) return 4;
    return 5;
  };
  const sortByOrderRecipientName = (a, b) => {
    const nameA = a.OrderRecipientName || "";
    const nameB = b.OrderRecipientName || "";
    const priorityA = getTypePriority(nameA);
    const priorityB = getTypePriority(nameB);
    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }
    return nameA.localeCompare(nameB, 'ja', { sensitivity: 'base' });
  };
  const SortListFun = (arr)=>{
    arr.sort((a,b)=>{
     if (!a) {
         return 1;
       } else if (!b) {
         return 1;
       } else {
         return a.localeCompare(b)
       }
     })
     return arr
 }
  const multiSort = (arr, ...sortFuncs)=> {
    return arr.sort((a, b) => {
      for (const func of sortFuncs) {
        const result = func(a, b);
        if (result !== 0) {
          return result;
        }
      }
      return 0;
    });
  }
    const [scrollTableWidth,setscrollTableWidth] = useState('101%')
    function calculateZoomLevel() {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const zoomLevel = ((windowWidth / screenWidth) + (windowHeight / screenHeight)) / 2;
      return Math.round(zoomLevel * 100);
    }
  useEffect(() => {
    let lastZoomLevel = calculateZoomLevel();
    async function getOrderRecipientItemSegGdcList() {
      let OrderRecipientItemSegGdcList = "";
      let listInfo = "";
      let orderRecipientCodeList = []
      let itemCodeList = []
      let productGroupsList = []
      let salesGroupList = []
      let marketList = []
      let segmentList = []
      let commodityGrpText2List = []
      let itemGroupList = []
      setProgress(true); // データのロード開始
      try {
        // 全ての情報を取得する
        listInfo = await API.graphql(
          graphqlOperation(listALLOrderRecipientItemSegGdc)
        );
        console.log(listInfo);
        OrderRecipientItemSegGdcList =
          listInfo.data.listALLOrderRecipientItemSegGdc["items"];

        let nextToken = listInfo.data.listALLOrderRecipientItemSegGdc.nextToken;

        while (nextToken !== null) {
          let InvDataSec = await API.graphql(
            graphqlOperation(listALLOrderRecipientItemSegGdc, {
              nextToken: nextToken,
            })
          );
          nextToken = InvDataSec.data.listALLOrderRecipientItemSegGdc.nextToken;
          for (
            let i = 0;
            i < InvDataSec.data.listALLOrderRecipientItemSegGdc.items.length;
            i++
          ) {
            OrderRecipientItemSegGdcList.push(
              InvDataSec.data.listALLOrderRecipientItemSegGdc.items[i]
            );
          }
        }
        console.log(OrderRecipientItemSegGdcList)
        for (let i = 0; i < OrderRecipientItemSegGdcList.length; i++) {
          if (OrderRecipientItemSegGdcList[i].OrderRecipientCode) {
            orderRecipientCodeList.push(OrderRecipientItemSegGdcList[i].OrderRecipientCode + ":" + OrderRecipientItemSegGdcList[i].OrderRecipientName)
            itemCodeList.push(OrderRecipientItemSegGdcList[i].ItemCode)
            productGroupsList.push(OrderRecipientItemSegGdcList[i].ProductGroups)
            salesGroupList.push(OrderRecipientItemSegGdcList[i].SalesGroup + ":" + OrderRecipientItemSegGdcList[i].SalesGroupName)
            OrderRecipientItemSegGdcList[i].Market && marketList.push(OrderRecipientItemSegGdcList[i].Market + ":" + OrderRecipientItemSegGdcList[i].MarketName)
            OrderRecipientItemSegGdcList[i].Segment && segmentList.push(OrderRecipientItemSegGdcList[i].Segment + ":" + OrderRecipientItemSegGdcList[i].SegmentName)
            commodityGrpText2List.push(OrderRecipientItemSegGdcList[i].CommodityGrpText2)
            itemGroupList.push(OrderRecipientItemSegGdcList[i].ItemGroup)
          }
        }
        setOrderRecipientCodeList(Array.from(new Set(orderRecipientCodeList)))
        setItemCodeList(Array.from(new Set(itemCodeList)))
        setProductGroupsList(SortListFun(Array.from(new Set(productGroupsList))))
        setSalesGroupList(SortListFun(Array.from(new Set(salesGroupList))))
        setMarketList(SortListFun(Array.from(new Set(marketList))))
        setSegmentList(SortListFun(Array.from(new Set(segmentList))))
        setCommodityGrpText2List(SortListFun(Array.from(new Set(commodityGrpText2List))))
        setItemGroupList(SortListFun(Array.from(new Set(itemGroupList))))
        OrderRecipientItemSegGdcList = multiSort(OrderRecipientItemSegGdcList,sortByOrderRecipientName)
        setOrderRecipientItemSegGdcList(OrderRecipientItemSegGdcList);
        const handleResize = () => {
          let dom = document.querySelector("#table");
          const newZoomLevel = calculateZoomLevel();
          if (lastZoomLevel !== newZoomLevel) {
            if (newZoomLevel > lastZoomLevel) {
              setscrollTableWidth(dom ? `101%` : `101%`)
            }else {
              let width = dom ? (`${dom.offsetWidth}` < 1632 ? `1632px` : '101%') : '101%';
              setscrollTableWidth(`${width}`)
            }
            lastZoomLevel = newZoomLevel;
          }
        };
        window.addEventListener('resize',handleResize, 100);
        return () => window.removeEventListener('resize', handleResize);
      } catch (err) {
        console.error(err);
      } finally {
        setProgress(false); // ロードが終了したら進行状態を更新
      }
    }
    getOrderRecipientItemSegGdcList();
  }, []);
  const headerStyle = {
    backgroundColor: "white",
    borderBottom: "3px solid #B45210",
  };
  let columns1 = [
    { dataField: "id", text: "ID", hidden: true },
    {
      dataField: "OrderRecipientCode",
      text: "受注先",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "100px",minWidth:"100px" },
    },
    {
      dataField: "OrderRecipientName",
      text: "受注先名称 1",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "180px",minWidth:"180px" },
    },
    {
      dataField: "ItemCode",
      text: "品目",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "130px",minWidth:"130px" },
    },
    {
      dataField: "SalesGroup",
      text: "営業Grp",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "120px",minWidth:"120px" },
    },
    {
      dataField: "SalesGroupName",
      text: "営業グループ名称",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "160px",minWidth:"160px" },
    },
    {
      dataField: "Market",
      text: "市場",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "40px",minWidth:"40px" },
    },
    {
      dataField: "MarketName",
      text: "市場名",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "80px",minWidth:"80px" },
    },
    {
      dataField: "Segment",
      text: "セグメント",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "120px",minWidth:"120px" },
    },
    {
      dataField: "SegmentName",
      text: "セグメント名",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "125px",minWidth:"125px" },
    },
    {
      dataField: "CommodityGrpText2",
      text: "商品 Grp テキスト 2",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "180px",minWidth:"180px" },
    },
    {
      dataField: "ItemGroup",
      text: "品目 Group",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "120px",minWidth:"120px" },
    },
    {
      dataField: "ProductGroups",
      text: "商品グループ",
      headerStyle,
      sort: true,
      style: { margin: "0px", width: "130px",minWidth:"130px" },
    },
  ];

  return (
    <Container
      style={{
        backgroundColor: "",
        minWidth: "100%",
        minHeight: "74vh",
        position: "relative",
      }}
    >
        <Row
          style={{
             borderRadius: "0.25em",
             color: "purple",
             padding: "0.5em",
              }}
            >
          <div style={{ display: 'flex', marginBottom: "10px",width:"100%"}}>
          <Col>
             <h4 style={{
                textAlign: "left",
                color: "black",
                height: 30,
                width: '20%',
                borderLeft: "4px solid #804F29",
                paddingLeft: "4px",
                whiteSpace:"nowrap"}}> 受注先品目セグメント誘導マスタ
            </h4>
          </Col>
        <div style={{ width: '80%', height: 220 }}>
           <div style={{ width: '90%',minWidth:"500px",height: 230, border: '2px solid rgb(191,191,191)', display: 'flex', flexWrap: "wrap",justifyContent:"center", padding: "30px 0px 0px 0px" }}>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >受注先
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={OrderRecipientCodeList}
                            value={searchValue.OrderRecipientCode}
                            name="OrderRecipientCode"
                            onChange={(e, value) => { searchValueChange(e, value,"OrderRecipientCode") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap" }}>
                         <InputGroup.Text
                            className={classes.textlabelSearch}
                            id="basic-name"
                            style={{ borderRadius: "0px",minWidth:"127px"}}
                          >品目
                         </InputGroup.Text>
                         <Autocomplete
                             className={classes.textFieldSearch}
                              sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                              options={ItemCodeList}
                              value={searchValue.ItemCode}
                              maxLength ="20"
                              onChange={(e, value) => { searchValueChange(e, value,"ItemCode") }}
                              name="ItemCode"
                              id="ItemCode"
                              isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                             renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                         />
                      </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >営業Grp
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={SalesGroupList}
                            value={searchValue.SalesGroup}
                            name="SalesGroup"
                            onChange={(e, value) => { searchValueChange(e, value,"SalesGroup") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >市場
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={MarketList}
                            value={searchValue.Market}
                            name="Market"
                            onChange={(e, value) => { searchValueChange(e, value,"Market") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >セグメント
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={SegmentList}
                            value={searchValue.Segment}
                            name="Segment"
                            onChange={(e, value) => { searchValueChange(e, value,"Segment") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option.split(":")[0] === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >商品Grp テキスト2
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={CommodityGrpText2List}
                            value={searchValue.CommodityGrpText2}
                            name="CommodityGrpText2"
                            onChange={(e, value) => { searchValueChange(e, value,"CommodityGrpText2") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >品目Group
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={ItemGroupList}
                            value={searchValue.ItemGroup}
                            name="ItemGroup"
                            onChange={(e, value) => { searchValueChange(e, value,"ItemGroup") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{ width: "50%", height: '25px' }}>
                      <InputGroup className="mb-3" style={{ width: "100%", display: 'flex', flexWrap: "nowrap", }}>
                         <InputGroup.Text
                             className={classes.textlabelSearch}
                             id="basic-name"
                             style={{ borderRadius: "0px",minWidth:"127px"}}
                         >商品グループ
                         </InputGroup.Text>
                           <Autocomplete
                            className={classes.textFieldSearch}
                            sx={{
                                display: 'inline-block',
                                '& input': {
                                    height: 0,
                                },
                            }}
                            options={ProductGroupsList}
                            value={searchValue.ProductGroups}
                            name="ProductGroups"
                            onChange={(e, value) => { searchValueChange(e, value,"ProductGroups") }}
                            renderInput={(params) => <TextField {...params} label="" variant="outlined" />}
                            isOptionEqualToValue={(option, value) => option === value || option === "" || value === ""}
                        />
                       </InputGroup>
              </div>
              <div style={{margin:"auto"}}>
                <Button className="btn" onClick={() => searchBtn()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: "3px solid black", background: "white",marginRight:'10px'}}>検索</Button>
                  <Button className="btn" onClick={() => searchClear()} style={{ height: 40, width: 120, fontSize: '16px', color: 'black', border: '3px solid black', background: "white"}}>Clear</Button>
              </div>
           </div>
        </div>
        </div>
        </Row>
        <div
            style={{
              width: "100%",
              height: "100%",
              overflowX: "scroll",
              transform: "scaleY(-1)",
            }}
          >
            <div
              style={{
                width: scrollTableWidth,
                height: "80vh",
                overflowY: "scroll",
                overflowX: "hidden",
                transform: "scaleY(-1)",
              }}
            >
            <div style={{ direction: "ltr" }}>
        <BootstrapTable
          id="table"
          striped={true}
          hover={true}
          wrapperClasses="boo bg-white"
          bootstrap4
          keyField="id"
          data={OrderRecipientItemSegGdcList}
          columns={columns1}
          noDataIndication={"no results found"}
          pagination={paginationFactory(options)}
          headerClasses={classes.fixedTop}
          />
        </div>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <CircularProgress
          size="3rem"
          disableShrink
          sx={{
            color: "#3f51b5",
            margin: "auto",
            display: progress ? "block" : "none",
            marginLeft: "60px",
          }}
        />
      </div>
    </Container>
  );
};

export default OrderRecipientItemSegGdcList;
